// Centralized localStorage keys for auth/session
export const ACCESS_TOKEN_STORAGE_KEY = 'access_token'
export const TOKEN_STORAGE_KEY = 'token'
export const USER_INFO_STORAGE_KEY = 'user_info'
// Indicates whether user balance from JWT token should be used
export const TOKEN_BALANCE_FRESH_STORAGE_KEY = 'token_balance_fresh'
// Literal string values used for the freshness flag
export const TOKEN_BALANCE_FRESH_TRUE = 'true' as const
export const TOKEN_BALANCE_FRESH_FALSE = 'false' as const
